import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';

export const API_CONFIG = {
	login: 'user/login',
	forgotPassword: 'user/forgot-password',
	resetPassword: 'user/reset-password',
	changePassword: 'user/change-password',
	user: 'user',
	userList: 'user/list',
	dropDownOption: 'user/dropdown-list',
	userRegister: 'user/register',
	userDetails: 'user/get-user',
	updateProfile: 'user/update-profile',
	userUpdate: 'user/update',
	master: 'master',
	verifyAccount: 'user/verify-account',
	resendVerificationEmail: 'user/resend-verification-email',
	addMaster: 'master/create',
	masterList: 'master/list',
	presignedUrl: 'user/presigned-url/upload',
	industrySales: 'sales/industry-sales',
	industrySalesSummary: 'sales/summary',
	downloadSalesSummaryExcel: 'reports/sales-summary/download',
	mySalesList: 'sales/my-sales',
	listSalesUpdate: 'sales/list-sales-update',
	addMySales: 'sales/create',
	updateMySales: 'sales/update',
	downloadMySalesExcel: 'reports/my-sales/excel/download',
	verifyMySalesExcel: 'sales/my-sales/verify-excel',
	verifyBulkMySalesExcel: 'admin/verify-excel',
	addBulkMySales: 'admin/historical-sales',
	notification: 'notification',
	readNotification: 'notification/read',
	getCreateMaster: 'notification/master/create',
	getUpdateMaster: 'notification/master/update',
	getDeleteMaster: 'notification/master/delete',
	getCreateSales: 'notification/sales/create',
	getUpdateSales: 'notification/sales/update',
	salesMasterDetails: 'sales/master-details',
	industrySalesDownloadPDF: 'reports/industry-sales/pdf/download',
	industrySalesDownloadExcel: 'reports/industry-sales/excel/download',
	industrySalesDownloadExcelMgFormat: 'reports/annual-sales-mg',
	downloadNotificationsExcel: 'reports/notifications/download',
	masterHistory: 'master/history',
	salesHistory: 'sales/history',
	markAllAsRead: 'notification/mark-all-read',
	userCount: 'user/user-count',
	masterFields: 'master/master-fields',
	news: 'news',
	newsPresignedUrl: 's3/presigned-url',
	polls: 'polls',
	endPoll: 'polls/end',
	voteNow: 'polls/vote',
	companyMappings: 'company-mappings',
	companyMappingHistory: 'company-mappings',
	markets: 'markets'
};

export const getUrl = (url: string, params: any = {}): string => {
	Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
	let urlString = url;
	if (params && !isEmpty(params)) {
		urlString += `?${queryString.stringify(params)}`;
	}
	return urlString;
};
